import config from "environment";
import { downloadRequest, getRequest, postRequest } from "./client";

const { baseApi } = config;

export async function apiPing() : Promise<any> {
  const fetchURL = `${baseApi}/ping`;
  return await getRequest(fetchURL, "API/apiPing");
}
